module.exports = __webpack_public_path__ + "static/octopus-2649c1cfd61fcaae0ed874eb105c98b5.svg";